import { atom } from "recoil";
export const isChangeLevelMenuOpenAtom = atom({
  key: "isChangeLevelMenuOpenAtom",
  default: false,
});
